import React, {useEffect, useRef, useState, useCallback} from "react";
import {useNavigate,useParams} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import Typography from '@mui/joy/Typography';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import JoditEditor from 'jodit-react';
import { toast } from 'react-toastify';
//SERVICES  
import ListService from "../../services/listService";
import DocumentService from "../../services/documentService";

function DocumentEdit() {

    const {docid} = useParams();
    const initDocument = {
        name: '',
        display_name: '',
        subject: '',
        signature_acknowledgment: 'false',
        sworn_statement_type: '',
        sworn_statement_type_id: '',
        signature_acknowledgment_mails: '',
        content_mail: '',
        statement: '',
    }
    const navigate = useNavigate();
    const [document, setDocument] = useState(initDocument);
    const [cargando, setCargando] = useState(true);
    const [listStatements, setListStatements] = useState([]);

    const config = {
        readonly: false,
        height: 400,
        toolbarButtonSize: 'middle',
        buttons: ['bold', 'italic', 'underline', 'link', 'unlink', 'ul', 'ol', 'lineHeight', 'hr', 'fontsize', 'left', 'center', 'right', 'justify', 'indent', 'outdent', 'source'],
    };
    
     useEffect(() => {
        if(cargando){ doLoad() }
    }, [false]);

    const doLoad = useCallback( async () => {
        try {  
            // STATMENTS TYPES
            const responseStatementTypes = await ListService.getSwornStatementTypesList()
            setListStatements(responseStatementTypes.data)   
            // DOCUMENT
            const responseDocument = await DocumentService.getDocumentById(docid)
            setDocument(responseDocument.data[0])
         } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        } finally{
            setCargando(false)
        }
    },[]);

    const doSave = async () => { 
        if(validateForm()){
            Swal.fire({
                title: "Atención!",
                text: "Ud. esta seguro que quiere actualizar el nuevo documento ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Crear",
                confirmButtonColor: "#83766d"
            }).then((result) => {
                if (result.isConfirmed) {
                    if(document.signature_acknowledgment === 'true'){ 
                        document.signature_acknowledgment = true; 
                    }else{
                        document.signature_acknowledgment = false;
                    }

                    DocumentService.putDocument(docid, document)
                        .then((response) => {
                            console.log("response: ", response.message);
                            let title = 'Documento actualizado!';
                            if(response.message !== null){  title = response.message; }
                            toast.success(title, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            }) 
                            navigate(-1); // volver a la pagina anterior
                        })
                        .catch((error) => {
                            if(error.response.status !== 401){
                                Swal.fire({
                                    title: 'Ooops?',
                                    text: error.response.data.errors[0].detail,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    confirmButtonColor: '#f13939'
                                })
                            }else{
                                sessionStorage.removeItem("userProfile");
                                navigate('/')
                                window.location.reload();
                            }
                        })
                        .finally(() => { setCargando(false) })
                } 
            });
        }else{
            Swal.fire({
                title: 'Ooops?',
                text: 'Debe completar los datos correctamente!',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#f13939'
            })
        }
    }

    const validateForm = function(){
        let rta = true;
        if(document.name === '' || document.name === undefined  || document.name === null){ return false; } 
        if(document.display_name  === '' || document.display_name === undefined  || document.display_name === null){ return false; } 
        if(document.subject === '' || document.subject === undefined  || document.subject === null){ return false; } 
        if(document.signature_acknowledgment === '' || document.signature_acknowledgment === undefined  || document.signature_acknowledgment === null){ return false; } 
        if(document.sworn_statement_type_id === '' || document.sworn_statement_type_id === undefined  || document.sworn_statement_type_id === null){ return false; } 
        if(document.content_mail === '' || document.content_mail === undefined  || document.content_mail === null){ return false; } 
        if(document.statement === '' || document.statement === undefined  || document.statement === null){ return false; } 
        if(document.signature_acknowledgment === 'true' && (document.signature_acknowledgment_mails === '' || document.signature_acknowledgment_mails === undefined  || document.signature_acknowledgment_mails === null)){ return false; } 
        return rta;
    }

    return (
        <div className="container-fluid flex-grow-1 container-p-y">

            <div className="row mb-3">
                <div className="col">
                    <h2>Editar Documento</h2>
                    <h6 className="card-subtitle text-muted">Editar un documento para su envio.</h6>
                </div>
            </div>
        
            {/* CABECERA */}
            <div className="card mb-3">
                <Grid className="card-body" container spacing={2} sx={{ flexGrow: 1 }}>        
                    <Grid xs={6}>
                        <FormControl>
                            <FormLabel className="form-labels">Título del Documento <span style={{color:'red'}}>*</span></FormLabel>
                            <Input type="text" size="md" placeholder="" value={document.name}  
                                onChange={(event, newValue) => { setDocument({...document, name: event.target.value}) }}
                            />
                            <p className="form-text">Las personas verán el título en el documento a firmar.</p>
                        </FormControl>
                    </Grid>
                    <Grid xs={6}>
                        <FormControl>
                            <FormLabel className="form-labels">Nombre <span style={{color:'red'}}>*</span></FormLabel>
                            <Input type="text" size="md" placeholder="" value={document.display_name}
                                onChange={(event, newValue) => { setDocument({...document, display_name: event.target.value}) }}
                            />
                            <p className="form-text">Nombre corto. Unicamente de uso interno.</p>
                        </FormControl>
                    </Grid>
                    <Grid xs={6}>
                        <FormControl>
                            <FormLabel className="form-labels">Asunto del email <span style={{color:'red'}}>*</span></FormLabel>
                            <Input type="text" size="md" placeholder="" value={document.subject}
                                onChange={(event, newValue) => { setDocument({...document, subject: event.target.value}) }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid xs={3}>
                        <FormControl>
                            <FormLabel className="form-labels">Acuse de Firma <span style={{color:'red'}}>*</span></FormLabel>
                            <Select 
                                onChange={(event, newValue) => setDocument({...document, signature_acknowledgment: newValue}) }
                                value={document.signature_acknowledgment === true || document.signature_acknowledgment === 'true' ? 'true' : 'false'}
                            >
                                <Option value="true" label="Si">Si</Option>
                                <Option value="false" label="No">No</Option>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid xs={3}>
                        <FormControl>
                            <FormLabel className="form-labels">Tipo de Documento <span style={{color:'red'}}>*</span></FormLabel>
                            <Select 
                                    placeholder="" 
                                    onChange={(event, newValue) => setDocument({...document, sworn_statement_type_id: newValue}) }
                                    value={document.sworn_statement_type_id}
                            >
                                {listStatements.map( (obj) => 
                                    <Option value={obj.id} key={obj.id} label={obj.display_name}>{obj.display_name}</Option>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid xs={12}>
                        <FormControl>
                            <FormLabel className="form-labels">Casilla del email</FormLabel>
                            <Input type="text" size="md" placeholder="" disabled={document.signature_acknowledgment === 'false'} value={document.signature_acknowledgment_mails} 
                                onChange={(event, newValue) => { setDocument({...document, signature_acknowledgment_mails: event.target.value}) }}
                            />
                            <p className="form-text">En caso de más de una cuenta separarlas con ";".</p>
                        </FormControl>
                    </Grid>
                    <Grid xs={12}>
                        <FormControl>
                            <FormLabel className="form-labels">Mensaje del email <span style={{color:'red'}}>*</span></FormLabel>
                            <Textarea
                                onChange={(event, newValue) => { setDocument({...document, content_mail: event.target.value}) }}
                                minRows={4}
                                maxRows={4}
                                value={document.content_mail}
                            />
                        </FormControl>
                    </Grid>

                </Grid>                   
            </div>

            {/* DETALLE */}
            <div className="card">
                <Grid className="card-body" container spacing={2} sx={{ flexGrow: 1 }}>        
                    <Grid xs={12}>
                        <FormControl>
                            <FormLabel className="form-labels">Contenido del documento <span style={{color:'red'}}>*</span></FormLabel>
                            <JoditEditor
                                // ref={editor}
                                value={document.statement}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onChange={(newContent) => {}}
                                onBlur={(newContent) => { setDocument({...document, statement: newContent}) }}
                            />    
                        </FormControl>
                    </Grid>
                </Grid>
            </div>

            <div className="row mt-3">
                <div className="col text-start">
                     <Typography level="body-xs" style={{color:'red'}}>* obligatorios</Typography>
                </div>
                <div className="col text-end">
                    <button type="button" className="btn btn-info mb-2" onClick={doSave}>Guardar</button>
                </div>
            </div>
        
        </div>
    )

}

export default DocumentEdit;